import React, { useState } from 'react';
import { Stepper, Step, StepLabel, Button, Typography, Box, Drawer } from '@mui/material';
import logo from "../../Assets/img/Login/logo.png"
import { styled } from '@mui/material/styles';
import AdjustIcon from '@mui/icons-material/Adjust';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditUserInformation from './EditInformation.jsx/EditUserInformation';
import EditPurposeInterestsNotifications from './EditInformation.jsx/EditPurposeInterestsNotifications';
import EditUserType from './EditInformation.jsx/EditUserType';


const steps = ['User Information', 'Purpose Interests & Notifications', 'User Type' ];
const DotStepIcon = styled('div')(({ theme, active, completed }) => ({
    
    
  }));
  const DotStepIcon2 = ({ active, completed }) => (
    <DotStepIcon active={active} completed={completed}>
      <AdjustIcon sx={{ color: active || completed ? '#004878' : '#ccc' , fontSize:'30px' , display:completed ? 'none' :'block'}} />
      <CheckCircleIcon sx={{ color: active || completed ? '#004878' : '#ccc' , fontSize:'30px' , display:completed ? 'block' :'none'}} />
    </DotStepIcon>
  );

const EditAccountMainPage = () => {

    const [activeStep, setActiveStep] = useState(0);

    const getStepContent = (step) => {
        switch (step) {
        case 0:
            return (
                <div>
                    <EditUserInformation setActiveStep={setActiveStep}/>
                </div>);
        case 1:
            return (
                <div>
                    <EditPurposeInterestsNotifications setActiveStep={setActiveStep}/>
                </div>);
        case 2:
            return (
                <div>
                    <EditUserType setActiveStep={setActiveStep}/>
                </div>);
        default:
            return <Typography>Unknown step</Typography>;
        }
    };

  return (
    <div className='flex text-black'>
        <Drawer className="z-[12]" variant="permanent" open={true} sx={{ width: '500px', flexShrink: 0 , height:'100vh', padding:'50px',
            '& .MuiDrawer-paper': {
            width: '500px',
            boxSizing: 'border-box',
            borderRight:'none',
            padding:'30px'
          },
        }}>
            <Box sx={{ padding: 2 , display:'flex' , alignItems:'center', justifyContent:'center' , height:'100%' , backgroundColor:'#f4f5f5' , borderRadius:'30px'}}>
                <img src={logo} alt="Logo" width="180px" />
            </Box>
        </Drawer>
        <Box sx={{ width: '100%'  ,  padding:'40px 25px'  ,flexGrow:1 }}>
            <Box sx={{width:'100%'}}>

                <Typography variant='h5' className='text-center' sx={{fontWeight:600 , color:'#004878' , marginBottom:'30px'}}>Edit Profile</Typography>

                <Stepper activeStep={activeStep} sx={{ marginBottom: 2 }} alternativeLabel>
                    {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={DotStepIcon2}>{label}</StepLabel>
                    </Step>
                    ))}
                </Stepper>
                <Box>
                    {/* This is where the content for each step is rendered */}
                    <Box sx={{ marginBottom: 2 }}>
                        {getStepContent(activeStep)}
                    </Box>
                
                </Box>
            </Box>
        </Box>
    </div>
  )
}

export default EditAccountMainPage